<h4 class="text-center">{{ 'FULL_CLAIM_FOR_ORDER_NUMBER' | translate }} ({{ 'ORDER_NO' | translate }}: {{orderId}})</h4>
<div class="row justify-content-center">
    <div class="col-12 col-md-8 col-lg-5">
        <div class="form-group">
            <div class="row" [formGroup]="form">
                <lib-gung-text-area-input
                    gungTranslate="CLAIM_REASON"
                    formControlName="description"
                    [placeholder]="'DESCRIPTION' | translate"
                    [rowsNumber]="4"
                ></lib-gung-text-area-input>
            </div>

            <div class="row" [formGroup]="form">
                <lib-gung-text-area-input
                    gungTranslate="WHICH_SOLUTION_DO_YOU_WISH"
                    formControlName="solution"
                    [placeholder]="'WISHED_SOLUTION' | translate"
                    [rowsNumber]="4"
                ></lib-gung-text-area-input>
            </div>

            <div class="row" [formGroup]="form">
                <div class="col-12">
                    <button class="btn btn-outline-primary mt-3" (click)="inputFile.click()" >
                        + {{ "CHOOSE_IMAGES_OPTIONAL" | translate }}
                        <input hidden
                            #inputFile
                            type="file"
                            multiple
                            accept="image/*"
                            class="_custom-file-input"
                            id="inputGroupFile01"
                            aria-describedby="inputGroupFileAddon01"
                            (change)="addImages($event)"
                        />
                    </button>
                </div>
                <div class="col-12 d-flex flex-wrap gap-2 mt-3" *ngIf="imagePreviews.length">
                    <div *ngFor="let preview of imagePreviews; let i = index" class="position-relative">
                        <img [src]="preview.url" [alt]="preview.file.name"
                             style="width: 96px; height: 96px; object-fit: cover; border-radius: 4px; border: 1px solid #dee2e6;" />
                        <button type="button"
                                class="btn btn-sm btn-light position-absolute top-0 end-0 p-0 px-1"
                                style="line-height: 1;"
                                (click)="removeImage(i)"
                                [attr.aria-label]="'REMOVE' | translate">&times;</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="row justify-content-center mt-3">
    <div class="col-12 col-md-8 col-lg-5 d-flex justify-content-between">
        <button class="btn btn-outline-primary" (click)="cancel()" translate>CANCEL</button>
        <button class="btn btn-primary" (click)="postClaim()" translate>REGISTER_CLAIM</button>
    </div>
</div>
